// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const hookInterfaceSchema = z.object({
  id: z.number(),
  url: urlSchema,
  organization: urlSchema,
  hook: urlSchema,
  name: z.string(),
  description: z.string(),
  payload: z.record(z.unknown()),
  type: z.string(),
  metadata: z.record(z.unknown()),
});
